export default __webpack_public_path__ + "static/media/htc_logo_menu.5b7fdd75.svg";